export default __webpack_public_path__ + "static/media/EliteoneLogo.82b2f9c1.png";